<template>
    <Modal :prevent-scrolling="false" :allow-close="visible" max-width="max-w-4xl" rounded-size="rounded-3xl" @modal:close="handleClose()">
        <template #body>
            <div class="max-w-3xl gap-4 grid grid-cols-1 mx-auto">
                <subscription-purchase-options
                    :show-modal-to-users="true"
                    @subscribe="handleSubscribeToPremiumPlan"
                    @selectFreePlan="handleSelectFreePlan"
                    @goback="handleGoBack"
                    @selectedPackage="selectedPackage=true"
                />
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { ref } from 'vue'

import Modal from "../../components/modal";
import SubscriptionPurchaseOptions from "../../components/subscription-purchase-options.vue";

const submitting = ref(false)

const emit = defineEmits(['subscribe:premium-plan', 'select:free-plan', 'modal:close'])
const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
})

const handleSubscribeToPremiumPlan = () => {
    emit('subscribe:premium-plan')
}

const handleClose = async() => {
    emit("modal:close");
}

const selectedPackage = ref(false)

const handleGoBack = async() => {
    selectedPackage.value = true
}

const handleSelectFreePlan = () => {
    emit('select:free-plan')
}
</script>
